import React from "react";
import { Loader2 } from "lucide-react";

const Loading: React.FC = () => {
  return (
    <div
      className="mx-auto flex h-[80vh] max-w-full items-center justify-center"
      role="status"
      aria-label="Carregando"
    >
      <Loader2
        className="h-12 w-12 animate-spin text-[#DD6435]"
        aria-hidden
      />
    </div>
  );
};

export default Loading;
